var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _vm.userIsTalent
          ? _c("h1", [_vm._v("Manage Payment Details")])
          : _vm.userIsManager
          ? _c("h1", [_vm._v("Default Payment Details")])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-info",
            attrs: { "active-class": "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" Back\n      "),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("div", { staticClass: "panel panel-grey" }, [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "form-horizontal" }, [
              _vm.user.region.shortname === _vm.$regionNameAu
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateBsbNumber,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("BSB Number:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateBsbNumber.$model,
                                expression: "$v.stateBsbNumber.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.$v.stateBsbNumber.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateBsbNumber,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "BSB",
                              field: _vm.$v.stateBsbNumber,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  { staticClass: "col-sm-4 col-lg-3 control-label" },
                  [_vm._v("Account Name:")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8 col-lg-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$v.stateAccountName.$model,
                        expression: "$v.stateAccountName.$model",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.$v.stateAccountName.$model },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.$v.stateAccountName,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.$hasErrorClass(
                    _vm.$v.stateAccountNumber,
                    "form-group"
                  ),
                },
                [
                  _c(
                    "label",
                    { staticClass: "col-sm-4 col-lg-3 control-label" },
                    [_vm._v("Account Number:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8 col-lg-5" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateAccountNumber.$model,
                            expression: "$v.stateAccountNumber.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "account_number", type: "text" },
                        domProps: { value: _vm.$v.stateAccountNumber.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.stateAccountNumber,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Account number",
                          field: _vm.$v.stateAccountNumber,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameUk
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Sort Code:")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-lg-5" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateSortCode.$model,
                            expression: "$v.stateSortCode.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.$v.stateSortCode.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.stateSortCode,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameUk
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Bank Name:")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-lg-5" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateBankName.$model,
                            expression: "$v.stateBankName.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.$v.stateBankName.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.stateBankName,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameUk
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Bank Address:")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8 col-lg-5" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateBankAddress.$model,
                            expression: "$v.stateBankAddress.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.$v.stateBankAddress.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.stateBankAddress,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameUs
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateABARoutingNumber,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("ABA Routing Number:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateABARoutingNumber.$model,
                                expression: "$v.stateABARoutingNumber.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "aba_routing_number", type: "text" },
                            domProps: {
                              value: _vm.$v.stateABARoutingNumber.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateABARoutingNumber,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "ABA routing number",
                              field: _vm.$v.stateABARoutingNumber,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$soleTrader && (_vm.userIsTalent || _vm.userIsManager)
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Are you a sole trader?")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-8 col-lg-5" },
                      [
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "sole_trader",
                            options: _vm.booleanOptions,
                          },
                          model: {
                            value: _vm.$v.stateSoleTrader.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.stateSoleTrader, "$model", $$v)
                            },
                            expression: "$v.stateSoleTrader.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameAu
                ? _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: _vm.$hasErrorClass(_vm.$v.stateAbn, "form-group"),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("ABN:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateAbn.$model,
                                expression: "$v.stateAbn.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text" },
                            domProps: { value: _vm.$v.stateAbn.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateAbn,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: { label: "ABN", field: _vm.$v.stateAbn },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$statementBySupplier &&
              (_vm.userIsTalent || _vm.userIsManager)
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Upload statement by supplier")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-8 col-lg-5" },
                      [
                        _c("file-input", {
                          attrs: {
                            name: "statement_by_supplier",
                            prefix: "profile-payment-details",
                            "data-vv-as": "Statement by supplier",
                          },
                          model: {
                            value: _vm.$v.stateStatementBySupplier.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.stateStatementBySupplier,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.stateStatementBySupplier.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$superannuationNumber
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateMemberFund,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("Superannuation Fund:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateMemberFund.$model,
                                expression: "$v.stateMemberFund.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "member_fund",
                              type: "text",
                              "data-vv-as": "member_fund",
                            },
                            domProps: { value: _vm.$v.stateMemberFund.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateMemberFund,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "Superannuation Fund",
                              field: _vm.$v.stateMemberFund,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$isACA
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateSuperAnnuationFundABN,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("Superannuation Fund ABN:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateSuperAnnuationFundABN.$model,
                                expression:
                                  "$v.stateSuperAnnuationFundABN.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "superannuation_number_abn",
                              type: "text",
                              "data-vv-as": "superannuation_number_abn",
                            },
                            domProps: {
                              value: _vm.$v.stateSuperAnnuationFundABN.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateSuperAnnuationFundABN,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "Superannuation Fund ABN",
                              field: _vm.$v.stateSuperAnnuationFundABN,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$superannuationNumber
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateMemberNumber,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("Member Number:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateMemberNumber.$model,
                                expression: "$v.stateMemberNumber.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "member_number",
                              type: "text",
                              "data-vv-as": "member number",
                            },
                            domProps: {
                              value: _vm.$v.stateMemberNumber.$model,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateMemberNumber,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "Member Number",
                              field: _vm.$v.stateMemberNumber,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$superannuationNumber
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateSpinNumber,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("Spin Number:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateSpinNumber.$model,
                                expression: "$v.stateSpinNumber.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              name: "spin_number",
                              type: "text",
                              "data-vv-as": "spin number",
                            },
                            domProps: { value: _vm.$v.stateSpinNumber.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateSpinNumber,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "Spin Number",
                              field: _vm.$v.stateSpinNumber,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userIsManager
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v("Allow stars to add their own payment details")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-8 col-lg-5" },
                      [
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "allow_talent_change",
                            options: _vm.booleanOptions,
                          },
                          model: {
                            value: _vm.$v.stateAllowTalentChange.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.stateAllowTalentChange,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.stateAllowTalentChange.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              (!_vm.$vlastMode &&
                (_vm.user.region.shortname === _vm.$regionNameAu ||
                  _vm.user.region.shortname === _vm.$regionNameUk) &&
                (_vm.userIsTalent || _vm.userIsManager)) ||
              (_vm.$vlastMode &&
                _vm.user.region.shortname === _vm.$regionNameAu &&
                (_vm.userIsTalent || _vm.userIsManager))
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "col-sm-4 col-lg-3 control-label" },
                      [_vm._v(_vm._s(_vm.$t("Are you tax registered?")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-8 col-lg-5" },
                      [
                        _c("selectize", {
                          staticClass: "selectize selectize-single",
                          attrs: {
                            name: "gst_registered",
                            options: _vm.booleanOptions,
                          },
                          model: {
                            value: _vm.$v.stateGstRegistered.$model,
                            callback: function ($$v) {
                              _vm.$set(_vm.$v.stateGstRegistered, "$model", $$v)
                            },
                            expression: "$v.stateGstRegistered.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.paymentDetails.managers_details
                ? _c("div", { staticClass: "form-group" }, [_vm._m(0)])
                : _vm._e(),
              _vm._v(" "),
              !_vm.$isACA
                ? _c("div", { staticClass: "form-group" }, [_vm._m(1)])
                : _vm._e(),
              _vm._v(" "),
              _vm.$swiftCode
                ? _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateSwiftCode,
                        "form-group"
                      ),
                    },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("Swift Code:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateSwiftCode.$model,
                                expression: "$v.stateSwiftCode.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "swift_code", type: "text" },
                            domProps: { value: _vm.$v.stateSwiftCode.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateSwiftCode,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "Swift code",
                              field: _vm.$v.stateSwiftCode,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.region.shortname === _vm.$regionNameUk
                ? _c(
                    "div",
                    { class: ["form-group", _vm.errorClass("iban_number")] },
                    [
                      _c(
                        "label",
                        { staticClass: "col-sm-4 col-lg-3 control-label" },
                        [_vm._v("IBAN Number:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-8 col-lg-5" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.$v.stateIBANNumber.$model,
                                expression: "$v.stateIBANNumber.$model",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "iban_number", type: "text" },
                            domProps: { value: _vm.$v.stateIBANNumber.$model },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.$v.stateIBANNumber,
                                  "$model",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("vuelidate-help", {
                            attrs: {
                              label: "IBAN number",
                              field: _vm.$v.stateIBANNumber,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "panel-footer" },
            [
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  attrs: {
                    type: "submit",
                    click: _vm.handleSavePaymentDetailsCallback,
                  },
                },
                [_vm._v("\n            Save Payment Details\n          ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-lg-8" }, [
      _c("p", { staticClass: "text-danger pull-right" }, [
        _vm._v("Managers Details"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-lg-6 col-lg-offset-3" }, [
      _c("h3", [_vm._v("Optional")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtext" }, [
        _vm._v(
          "To be booked for opportunities from around the world please provide"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }